import apiClient from '@/services/axios'

export async function patch(bookingId, arrival) {
  var arrivalRequest = {
    "note": arrival.note
  }

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/' + bookingId + '/arrived/' + arrival.numberOfGuests, arrivalRequest);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch booking items arrival count.')
}
